export enum ScopeOfWorkStep {
  Categories = "categories",
  TypeOfPlaces = "type-of-places",
  TypeOfService = "type-of-service",
  Areas = "areas",
  Objects = "objects",
  SpecialRequests = "special-requests",
  Summary = "summary",
}

export type ScopeOfWorkStepValue = `${ScopeOfWorkStep}`;

export type WithExtras<T extends object> = T & Record<string, any>;

export type Category = WithExtras<{
  uid: string;
  name: "Commercial" | "Residential";
  description?: string;
  createdAt?: string;
  updatedAt?: string;
}>;

export type Place = WithExtras<{
  uid: string;
  name: string;
  description?: string;
  category?: Category;
}>;

export type Service = WithExtras<{
  uid: string;
  name: string;
  description?: string;
}>;

export type SquareFootage = WithExtras<{ quantity: number }>;

export type Task = WithExtras<{
  uid: string;
  name: string;
  active: boolean;
  note?: string;
}>;

export type Area = WithExtras<{
  uid: string;
  name: string;
  description?: string;
  imageUrl?: string;
  squareFootages: SquareFootage[];
  tasks: Task[];
}>;

export type CleaningObject = WithExtras<{
  uid: string;
  name: string;
  description?: string;
  cost?: { value: number } & Record<string, any>;
}>;

export type SpecialRequest = WithExtras<{
  uid: string;
  name: string;
  imageUrl?: string;
  description?: string;
}>;

export type ScopeOfWorkState = WithExtras<{
  step: ScopeOfWorkStep;
  isComplete: boolean;

  squareft: string | null;
  averagePeople: number | null;

  category: Category | null;
  places: Place | null;
  service: Service | null;

  areas: Area[];
  otherAreas: Area[];
  objects: CleaningObject[];
  specialRequests: SpecialRequest[];

  lastAreasSquareFtInitialized?: number | null;
}>;

const STEP_VALUES = new Set<string>(Object.values(ScopeOfWorkStep));

export const isScopeOfWorkStep = (v: unknown): v is ScopeOfWorkStep => {
  return typeof v === "string" && STEP_VALUES.has(v);
};

export const coerceScopeOfWorkStep = (v: unknown, fallback: ScopeOfWorkStep = ScopeOfWorkStep.Categories): ScopeOfWorkStep => {
  return isScopeOfWorkStep(v) ? (v as ScopeOfWorkStep) : fallback;
};

export type ScopeOfWorkInitialPayload = Partial<Omit<ScopeOfWorkState, "step">> & {
  step?: ScopeOfWorkStep | string;
  [key: string]: any;
};
